import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'

const SyncModalContainer = ({
    currentItem, 
    toggleView, 
  }) => { 

    // useLayoutEffect(() => {
    //     setTimeout(() => {
          
    //         const hasScroll = dpRef.current.clientHeight < dpRef.current.scrollHeight
    //         setHasScroll(hasScroll)
    //     }, 20)
    // }, [])

    const renderRow = (hasExclude, item) => (
        <tr className={`${hasExclude && !item.sync ? "excluded" : item.sync ? 'sync' : ''}`}>
            <td>{item.warehouseType}</td>
            <td>{item.storageBinId}</td>
        </tr>
        )
    

    return (
        <Modal
        className="irc-supply-new-view-modal sync-modal"
        title={"Posições sincronizadas"}
        confirmButtonText={"Fechar"}
        hideCancelButton
        disabledBgClickClosing
        isOpen
        size={'md'}
        onCloseModal={() => toggleView(false)}
        center
        onConfirm={() => toggleView(false)}
      >
        <Fragment>
       
            <div  className='irc-supply-sync-modal'>
                <table>
                    <thead>
                        <tr>
                            <th>Depósito</th>
                            <th>Posição</th>
                        </tr>
                    </thead>

                    <tbody>
                        {currentItem.storageBinList.map(sbl => renderRow(currentItem.excluded, sbl))}
                    </tbody>
                </table>

            </div>
          
        </Fragment>
      </Modal>
    )
  }

  SyncModalContainer.propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    currentItem: PropTypes.object,
    toggleView: PropTypes.func,
    toggleEdit: PropTypes.func,
    toggleUpload: PropTypes.func,

  }

export {SyncModalContainer}